import useNativeSmt from '@swarm/core/hooks/data/useNativeSmt'
import { BasicModalProps } from '@swarm/core/hooks/state/usePopupState'
import { generateExplorerUrl } from '@swarm/core/shared/utils'
import { normalize } from '@swarm/core/shared/utils/helpers/big-helpers'
import { NormalizedStake } from '@swarm/types/normalized-entities'
import Dialog from '@swarm/ui/presentational/Dialog'
import Chip from '@swarm/ui/swarm/Buttons/Chip'
import TokenIcon from '@swarm/ui/swarm/TokenIcon'
import { TransactionResult } from 'contract-proxy-kit'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Flex, Text } from 'rimble-ui'

interface UnstakeSecurityPopupProps extends BasicModalProps {
  stake: NormalizedStake
  tx?: TransactionResult
}

const UnstakeSecurityPopup = ({
  isOpen,
  onClose,
  stake,
  tx,
}: UnstakeSecurityPopupProps) => {
  const { t } = useTranslation('staking')
  const { nativeSmt } = useNativeSmt()

  const { stakedAmount, stakedSecurity } = stake

  const unstakedAmount = nativeSmt?.decimals
    ? normalize(stakedAmount, nativeSmt.decimals)
    : '--'

  const explorerUrl = useMemo(
    () => tx && generateExplorerUrl({ type: 'tx', hash: tx.hash }),
    [tx],
  )

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      width={['100%', '550px']}
      maxHeight={['90%', '80%']}
      height="auto"
      padding={0}
    >
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        mb={3}
      >
        <TokenIcon
          symbol={stakedSecurity?.symbol}
          height="95px"
          maxWidth="95px"
        />
        <Text fontSize={4} fontWeight={5} mt={2} mb={2} color="primary">
          {t('unstakeSecurityPopup.title', {
            amount: unstakedAmount,
            symbol: stakedSecurity.symbol,
          })}
        </Text>

        <Chip.Link href={explorerUrl} target="_blank">
          {t('unstakeSecurityPopup.viewTx')}
        </Chip.Link>
      </Flex>

      <Flex justifyContent="center">
        <Button.Outline
          height="36px"
          px="94px"
          py="6px"
          borderColor="primary"
          border="1.5px solid"
          fontWeight={4}
          onClick={onClose}
        >
          {t('stakingDetails.close')}
        </Button.Outline>
      </Flex>
    </Dialog>
  )
}

export default UnstakeSecurityPopup
